interface GlossaryTerm {
  term: string;
  definition: string;
}

interface GlossaryReferenceLink {
  label: string;
  href: string;
}

interface GlossaryGridProps {
  terms: GlossaryTerm[];
  intro?: string;
  references?: GlossaryReferenceLink[];
}

export default function GlossaryGrid({
  terms,
  intro,
  references,
}: GlossaryGridProps) {
  if (!Array.isArray(terms) || terms.length === 0) {
    throw new Error("GlossaryGrid: `terms` array is empty or invalid.");
  }
  if (references && references.length !== 2) {
    throw new Error("GlossaryGrid: `references` must contain exactly two links.");
  }

  return (
    <div className="glossary">
      {intro ? <p className="glossary-intro">{intro}</p> : null}
      {references ? (
        <p className="glossary-intro">
          Weitere Details zur Plattform finden Sie in der offiziellen{" "}
          <a
            href={references[0].href}
            rel="noopener noreferrer"
            target="_blank"
          >
            {references[0].label}
          </a>{" "}
          sowie in den{" "}
          <a
            href={references[1].href}
            rel="noopener noreferrer"
            target="_blank"
          >
            {references[1].label}
          </a>
          .
        </p>
      ) : null}
      <div className="glossary-grid">
        {terms.map((item) => (
          <article key={item.term} className="glossary-card">
            <h3 className="glossary-term">{item.term}</h3>
            <p className="glossary-def">{item.definition}</p>
          </article>
        ))}
      </div>
    </div>
  );
}
